export default __webpack_public_path__ + "static/media/franconia_ridge_thumb.96a903e9.jpeg";